import { useEffect, useState } from 'react';

type ExpandedGroups = {
  [key: string]: boolean;
};

export const useExpandedGroups = () => {
  const [storageKey, setStorageKey] = useState<string>('');

  const [expandedGroups, setExpandedGroups] = useState<ExpandedGroups>(() => {
    const storedGroups = localStorage.getItem(storageKey);
    return storedGroups ? JSON.parse(storedGroups) : {};
  });

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(expandedGroups));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandedGroups]);

  const setExpandedGroup = (group: string, expanded: boolean, key?: string) => {
    setStorageKey(key || '');
    setExpandedGroups((prev) => ({
      ...prev,
      [group]: expanded,
    }));
  };

  return {
    expandedGroups,
    setExpandedGroup,
  };
};
